<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h4 class="card-title">Общая информация
        </h4>
      </div>
      <div class="card-body">
        <b-form @submit.prevent>
          <b-row>
            <b-col md="6">
              <b-form-group
                label="Название новости"
              >
                <b-form-input
                  v-model="oneNews.title"
                  placeholder="Название новости"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </div>
    </div>

    <div class="card">
      <div class="card-header">
        <h4 class="card-title">
          Категория
        </h4>
      </div>
      <span class="bv-no-focus-ring col-form-label pt-0 categoryLabel">
        Выберите категорию
      </span>
      <v-select
        v-model="selectedCategory"
        :close-on-select="false"
        :options="categories"
        :reduce="category => category"
        label="name"
        input-id="name"
        class="select"
        :value="selectedCategory"
      />
    </div>

    <div class="card">
      <div class="card-header">
        <h4 class="card-title">
          Теги
        </h4>
      </div>
      <div
        v-if="hashtags.length > 0"
        class="tagWrap"
      >
        <div
          v-for="(item, index) in hashtags"
          :key="item + index"
        >
          <span>{{ item.name }}</span>
          <x-icon
            stroke="black"
            size="1x"
            class="cursor"
            @click="deleteTag(item.name)"
          />
        </div>
      </div>
      <div class="card-body">
        <b-form @submit.prevent>
          <b-row>
            <b-col
              md="6"
              cols="12"
            >
              <b-form-group
                label="Название тега"
              >
                <div class="flex-row">
                  <vue-autosuggest
                    v-model="tag"
                    class="autosuggest-input"
                    :suggestions="filteredTags"
                    :input-props="{class: 'form-control'}"
                    placeholder="Введите тег"
                    @input="searchTags"
                    @keyup.enter="submit"
                    @selected="selected"
                  >
                    <div slot-scope="{suggestion}">
                      <span
                        v-if="filteredTags"
                        class="my-suggestion-item cursor"
                      >{{ suggestion.item.name }}</span>
                    </div>
                  </vue-autosuggest>

                  <plus-icon
                    size="1.5x"
                    class="cursor"
                    @click="submit"
                  />
                </div>
              </b-form-group>
            </b-col>
            <b-col
              md="6"
              cols="12"
            >
              <div class="popular-tags-panel">
                <div class="popular-tags-panel__header">
                  <span class="popular-tags-panel__title">Популярные теги</span>
                  <b-button
                    variant="link"
                    class="p-0 popular-tags-panel__link"
                    @click="isAllTagsModalVisible = true"
                  >
                    Посмотреть все
                  </b-button>
                </div>
                <b-spinner
                  v-if="isTagsLoading"
                  small
                  class="mt-1"
                />
                <div
                  v-else-if="popularTags.length"
                  class="popular-tags-panel__list"
                >
                  <b-badge
                    v-for="item in popularTags"
                    :key="item.id"
                    :variant="isTagSelected(item.name) ? 'light-secondary' : 'light-primary'"
                    class="popular-tags-panel__tag cursor"
                    pill
                    @click="addTagByName(item.name)"
                  >
                    {{ item.name }}
                    <span class="text-muted">({{ item.newsCount }})</span>
                  </b-badge>
                </div>
                <div
                  v-else
                  class="text-muted mt-1"
                >
                  Теги не найдены
                </div>
              </div>
            </b-col>
          </b-row>
        </b-form>
      </div>

      <all-tags-modal
        :visible="isAllTagsModalVisible"
        :tags="allTags"
        :selected-tag-names="selectedTagNames"
        @close="isAllTagsModalVisible = false"
        @select="onTagSelectFromModal"
      />
    </div>
    <div class="card">
      <div class="card-body">
        <b-form @submit.prevent>
          <b-row>
            <b-col
              v-if="oneNews.main_image"
              md="6"
            >
              <h4 class="card-title">
                Обложка
              </h4>
              <div class="images-container mb-3">
                <div
                  class="image-container"
                >
                  <img
                    :src="oneNews.main_image.fullPath"
                    alt=""
                  >
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    class="delete-image-button"
                    @click="deleteMainImage"
                  >
                    Удалить
                  </b-button>
                </div>
              </div>
            </b-col>
            <b-col
              v-if="oneNews.images.length"
              md="6"
            >
              <h4 class="card-title">
                Дополнительные фото
              </h4>
              <div class="images-container mb-3">
                <div
                  v-for="(image, index) in oneNews.images"
                  :key="image.id"
                  class="image-container"
                >
                  <img
                    :src="image.fullPath"
                    alt=""
                  >
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    class="delete-image-button"
                    @click="oneNews.images.splice(index, 1)"
                  >
                    Удалить
                  </b-button>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <div class="upload-wrap">
                <file-uploader
                  title="Обложка новости"
                  hide-control-buttons
                  @updatePhotos="addMainImage"
                />
              </div>
            </b-col>
            <b-col md="6">
              <div class="upload-wrap">
                <file-uploader
                  title="Доп. изображение"
                  hide-control-buttons
                  @updatePhotos="addImage"
                />
              </div>
            </b-col>
          </b-row>
        </b-form>
      </div>
    </div>

    <div class="card">
      <div class="card-header" />
      <div class="card-body">
        <h4 class="card-title">
          Описание
        </h4>
        <div class="my-1">
          Полное описание
        </div>
        <admin-quill-editor
          v-model="oneNews.full_description"
          :options="quillEditorOptions"
        />
        <div class="mt-5 mb-3">
          <b-form-checkbox
            v-model="showShortDescription"
            class="custom-control-primary"
          >
            Добавить краткое описание
          </b-form-checkbox>
        </div>
        <div v-if="showShortDescription">
          <div class="my-1">
            Краткое описание
          </div>
          <admin-quill-editor
            v-model="oneNews.short_description"
            :options="quillEditorOptions"
          />
        </div>
      </div>
    </div>

    <b-col>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        type="submit"
        variant="primary"
        class="mr-1 save-post-button"
        :disabled="isloading"
        @click="saveItem"
      >
        <b-spinner
          v-if="isloading"
          small
        />
        {{ isloading ? 'Сохранение...' : 'Сохранить' }}
      </b-button>
    </b-col>
  </div>
</template>

<script>
import {
  BBadge,
  BButton,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BSpinner,
  VBPopover,
  BFormCheckbox,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { VueAutosuggest } from 'vue-autosuggest'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { Russian } from 'flatpickr/dist/l10n/ru'
import { PlusIcon, XIcon } from 'vue-feather-icons'
import FileUploader from '@/global-components/FileUploader'
import newsTagsModule from '@/libs/news_tags_module'
import AllTagsModal from './tags/AllTagsModal.vue'
import crudModule from '../../libs/crud_module'
import { buildQuillOptions } from '@/plugins/quill-config'

const POPULAR_TAGS_LIMIT = 10

const oneNewsModule = crudModule({
  entity_name: 'news',
})
const categoriesModule = crudModule({
  entity_name: 'news-category',
})
const tagsModule = crudModule({
  entity_name: 'hash-tag/news',
})

export default {
  name: 'OneNewsPage',
  components: {
    PlusIcon,
    XIcon,
    FileUploader,
    AllTagsModal,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BSpinner,
    BBadge,
    VueAutosuggest,
    BFormCheckbox,
  },
  directives: {
    'b-popover': VBPopover,
    Ripple,
  },
  computed: {
    quillEditorOptions() {
      return buildQuillOptions({
        startId: null,
        requireStartPick: true,
        includeStartInShortcode: true,
      })
    },
  },
  data() {
    return {
      config: {
        allowInput: true,
        altFormat: 'd.m.Y H:i',
        altInput: true,
        enableTime: true,
        dateFormat: 'Z',
        locale: Russian, // locale for this instance only
      },
      isloading: false,
      oneNews: {
        images: [],
        main_image: null,
      },
      tag: '',
      categories: [],
      selectedCategory: {},
      hashtags: [],
      filteredTags: [],
      debounceTimeout: null,
      showShortDescription: false,
      allTags: [],
      isTagsLoading: false,
      isAllTagsModalVisible: false,
    }
  },
  computed: {
    popularTags() {
      return [...this.allTags]
        .sort((a, b) => b.newsCount - a.newsCount || a.name.localeCompare(b.name, 'ru'))
        .slice(0, POPULAR_TAGS_LIMIT)
    },
    selectedTagNames() {
      return this.hashtags.map(item => item.name)
    },
  },
  watch: {
    selectedCategory() {
      this.oneNews.categoryId = this.selectedCategory.id
    },
    hashtags() {
      this.oneNews.hashtags = this.hashtags
    },
    showShortDescription(newValue) {
      // Очищаем краткое описание при снятии галочки
      if (!newValue) {
        this.oneNews.short_description = ''
      }
    },
  },
  async created() {
    this.loadAllTags()

    if (this.$route.params.id === 'new') {
      const response = await categoriesModule.fetchItems()
      this.categories = response.data.rows
    } else {
      try {
        await oneNewsModule.fetchItem(this.$route.params.id, {
          query: {
            admin: '1',
          },
        }).then(result => {
          this.oneNews = {
            ...result.data,
            images: result.data.images.length !== 0 ? result.data.images : [],
          }
          this.hashtags = result.data.hashtags
          // Автоматически показываем чекбокс, если есть краткое описание
          if (result.data.short_description) {
            this.showShortDescription = true
          }
        })

        await categoriesModule.fetchItems().then(response => {
          this.categories = response.data.rows
          this.selectedCategory = this.categories.find(item => {
            if (item.id === this.oneNews.categoryId) {
              return item
            }
          })
        })
      } catch (e) {
        console.error(e)
      }
    }
  },
  methods: {
    async loadAllTags() {
      this.isTagsLoading = true
      try {
        const response = await newsTagsModule.getList()
        this.allTags = response.data || []
      } catch (error) {
        console.error(error)
      } finally {
        this.isTagsLoading = false
      }
    },
    isTagSelected(name) {
      return this.hashtags.some(
        item => item.name.toLowerCase() === name.toLowerCase(),
      )
    },
    addTagByName(name) {
      const trimmedName = name.trim()
      if (!trimmedName || this.isTagSelected(trimmedName)) return
      this.hashtags.push({ name: trimmedName })
    },
    onTagSelectFromModal(tag) {
      this.addTagByName(tag.name)
    },
    deleteTag(selectedTagName) {
      this.hashtags = this.hashtags.filter(item => item.name !== selectedTagName)
    },
    submit(e) {
      if (e?.target?.value !== undefined) {
        e.target.value = ''
      }
      this.addTagByName(this.tag)
      this.tag = ''
    },
    fetchTags() {
      if (this.tag) {
        tagsModule.fetchItems({ filterText: this.tag }).then(res => {
          this.filteredTags = [{ data: res.data }]
        })
      } else {
        this.filteredTags = []
      }
    },
    searchTags() {
      clearTimeout(this.debounceTimeout)
      this.debounceTimeout = setTimeout(this.fetchTags, 300)
    },
    selected(item) {
      this.tag = item.item.name
    },
    saveItem() {
      if (this.oneNews.images.length) {
        this.oneNews.images = this.oneNews.images.map(img => img.id)
      }

      if (this.$route.params.id === 'new') {
        this.createNews()
      } else {
        this.updateNews()
      }
    },
    addImage(image) {
      this.oneNews.images.push(image)
    },
    addMainImage(image) {
      this.oneNews.mainImageId = image.id
      this.oneNews.main_image = image
      console.log(this.oneNews)
    },
    deleteMainImage() {
      this.oneNews.mainImageId = null
      this.oneNews.main_image = null
    },
    async updateNews() {
      try {
        await oneNewsModule.updateItem(this.oneNews.id, this.oneNews)
          .then(response => {
            this.isloading = false
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Уведомление',
                icon: 'BellIcon',
                text: 'Новость сохранена',
                variant: 'success',
              },
            })
            this.$router.push({ name: 'news' })
            return response
          })
          .catch(error => {
            this.isloading = false
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Уведомление',
                icon: 'BellIcon',
                text: error.response.data.message,
                variant: 'danger',
              },
            })
          })
      } catch (e) {
        this.isloading = false
        console.error(e)
      }
    },
    async createNews() {
      try {
        await oneNewsModule.createItem(this.oneNews)
          .then(response => {
            this.isloading = false
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Уведомление',
                icon: 'BellIcon',
                text: 'Новость добавлена',
                variant: 'success',
              },
            })
            this.$router.push({ name: 'news' })
            return response
          })
          .catch(error => {
            this.isloading = false
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Уведомление',
                icon: 'BellIcon',
                text: error.response.data.message,
                variant: 'danger',
              },
            })
          })
      } catch (e) {
        this.isloading = false
        console.error(e)
      }
    },
  },
}
</script>

<style lang="scss">
  .upload-wrap{
    margin-bottom: 20px;
  }
  .save-post-button{
    position: fixed !important;
    bottom: 30px;
    right: 15px;
    z-index: 1000;
  }
  .tagWrap {
    margin: 20px 20px 0;
    display: flex;
    gap: 10px;
  }
  .select {
    padding: 0 21px 21px;
    width: 100%;
  }
  .cursor {
    cursor: pointer
  }
  .categoryLabel {
    padding-left: 21px;
  }
  .flex-row {
    display: flex;
    gap: 20px;
    align-items: center;
  }
  .popular-tags-panel {
    height: 100%;
    padding: 0.25rem 0 0 0.5rem;

    @media (max-width: 767.98px) {
      margin-top: 1rem;
      padding: 0;
      padding-top: 1rem;
    }

    &__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 0.75rem;
    }

    &__title {
      font-weight: 500;
      color: #5e5873;
    }

    &__link {
      font-size: 0.9rem;
    }

    &__list {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
    }

    &__tag {
      font-size: 0.85rem;
      padding: 0.4rem 0.7rem;
      cursor: pointer;
      user-select: none;

      &:hover {
        opacity: 0.85;
      }
    }
  }
  .autosuggest-input {
    width: 100%;
    position: relative;
  }
  .autosuggest__results-container {
    position: absolute;
    z-index: 1000;
    width: 100%;
    background-color: #fff;
  }
  .autosuggest__results {
    box-shadow: 4px 4px 24px 4px rgba(34, 41, 47, 0.1);
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  .autosuggest__results ul {
    list-style-type: none;
  }
  .dark-layout .autosuggest__results-container {
    background-color: #283046;
  }
  .my-suggestion-item {
    display: flex;
    justify-content: start;
    padding: 3px;
  }

.autosuggest__results-item--highlighted {
  background-color: #7367f0;
  color: #fff;
}
@import '@core/scss/vue/libs/vue-select.scss';
</style>
<style lang="scss" scoped>
.images-container {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;

  .image-container {
    max-width: 200px;
    min-width: 150px;
    height: 250px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 15px;
    padding: 10px;
    border-radius: 10px;
    box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);

    img {
      height: 180px;
      border-radius: 10px;
    }

    .delete-image-button {
      width: min-content;
      align-self: center;
    }
  }
}
</style>
